// Configuraciones y Constantes de TorneosPro
//
// Cada deporte declara:
// - configTabs:    qué pestañas mostrar en el modal del torneo
// - scoringSystem: el sistema de puntuación que usa ('wdl', 'wl', 'sets', 'sets-tennis', 'tantos', 'wdl-bonus')
// - terms:         nombres específicos del deporte (gol vs punto vs tanto, tiempo vs cuarto vs set...)
// - defaultConfig: valores por defecto al crear un torneo nuevo
//
// Sistemas de puntuación:
//   wdl        — Win/Draw/Loss clásico con puntos por victoria/empate/derrota (fútbol, balonmano, hockey, fútbol playa)
//   wl         — Win/Loss sin empate posible (baloncesto: si empatan se va a prórroga sí o sí)
//   sets       — Por sets con puntos según el resultado (3-0=3, 3-1=3, 3-2=2…) tipo voleibol
//   sets-tennis— Por sets pero el ganador es el que gana N sets (tenis/pádel) sin puntos por set
//   tantos     — Carrera a N tantos (pelota: a 22, a 35…)
//   wdl-bonus  — Como wdl pero con bonificación ofensiva (rugby: bono por 4+ ensayos, bono por perder por menos de 7)

export const SCORING_SYSTEMS = {
  wdl:          { label: 'Victoria / Empate / Derrota',     hasDraw: true,  hasOvertime: true,  hasPenalties: true  },
  wl:           { label: 'Victoria / Derrota',              hasDraw: false, hasOvertime: true,  hasPenalties: false },
  sets:         { label: 'Por sets (con puntos por resultado)', hasDraw: false, hasOvertime: false, hasPenalties: false },
  'sets-tennis':{ label: 'Por sets (tenis / pádel)',        hasDraw: false, hasOvertime: false, hasPenalties: false },
  tantos:       { label: 'Carrera a tantos',                hasDraw: false, hasOvertime: false, hasPenalties: false },
  'wdl-bonus':  { label: 'Victoria / Empate / Derrota con bonificación', hasDraw: true, hasOvertime: true, hasPenalties: false },
};

// Pestañas del modal del torneo: cada deporte indica cuáles ver
export const ALL_CONFIG_TABS = ['scoring', 'overtime', 'match', 'knockout', 'tiebreakers', 'visibility', 'sponsors'];

export const SPORT_CONFIGS = {
  futsal: {
    name: 'Fútbol Sala',
    icon: 'fa-futbol',
    color: '#16213e',
    scoreLabel: 'Goles',
    scoringSystem: 'wdl',
    configTabs: ['scoring', 'overtime', 'match', 'knockout', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'gol', scorePlural: 'goles', period: 'tiempo', periodPlural: 'tiempos' },
    defaultConfig: {
      pointsWin: 3, pointsDraw: 1, pointsLoss: 0, allowDraw: true,
      hasOvertime: true, hasPenalties: true,
      pointsWinOvertime: 3, pointsLossOvertime: 0,
      pointsWinPenalties: 2, pointsLossPenalties: 1,
      matchDuration: 40, periods: 2, overtimeDuration: 10,
      knockoutTwoLegs: false, awayGoalsRule: false,
      tiebreakers: ['points', 'headToHead', 'goalDifference', 'goalsFor', 'wins']
    }
  },
  football7: {
    name: 'Fútbol 7',
    icon: 'fa-futbol',
    color: '#1b5e20',
    scoreLabel: 'Goles',
    scoringSystem: 'wdl',
    configTabs: ['scoring', 'overtime', 'match', 'knockout', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'gol', scorePlural: 'goles', period: 'tiempo', periodPlural: 'tiempos' },
    defaultConfig: {
      pointsWin: 3, pointsDraw: 1, pointsLoss: 0, allowDraw: true,
      hasOvertime: false, hasPenalties: true,
      pointsWinOvertime: 3, pointsLossOvertime: 0,
      pointsWinPenalties: 2, pointsLossPenalties: 1,
      matchDuration: 50, periods: 2, overtimeDuration: 10,
      knockoutTwoLegs: false, awayGoalsRule: false,
      tiebreakers: ['points', 'headToHead', 'goalDifference', 'goalsFor', 'wins']
    }
  },
  football11: {
    name: 'Fútbol 11',
    icon: 'fa-futbol',
    color: '#2e7d32',
    scoreLabel: 'Goles',
    scoringSystem: 'wdl',
    configTabs: ['scoring', 'overtime', 'match', 'knockout', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'gol', scorePlural: 'goles', period: 'tiempo', periodPlural: 'tiempos' },
    defaultConfig: {
      pointsWin: 3, pointsDraw: 1, pointsLoss: 0, allowDraw: true,
      hasOvertime: true, hasPenalties: true,
      pointsWinOvertime: 3, pointsLossOvertime: 0,
      pointsWinPenalties: 2, pointsLossPenalties: 1,
      matchDuration: 90, periods: 2, overtimeDuration: 30,
      knockoutTwoLegs: true, awayGoalsRule: true,
      tiebreakers: ['points', 'headToHead', 'goalDifference', 'goalsFor', 'wins']
    }
  },
  basketball: {
    name: 'Baloncesto',
    icon: 'fa-basketball',
    color: '#e65100',
    scoreLabel: 'Puntos',
    scoringSystem: 'wl',
    configTabs: ['scoring', 'overtime', 'match', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'punto', scorePlural: 'puntos', period: 'cuarto', periodPlural: 'cuartos' },
    defaultConfig: {
      pointsWin: 2, pointsDraw: 0, pointsLoss: 1, allowDraw: false,
      hasOvertime: true, hasPenalties: false,
      pointsWinOvertime: 2, pointsLossOvertime: 1,
      pointsWinPenalties: 0, pointsLossPenalties: 0,
      matchDuration: 40, periods: 4, overtimeDuration: 5,
      knockoutTwoLegs: false, awayGoalsRule: false,
      tiebreakers: ['points', 'pointsDifference', 'pointsFor', 'headToHead', 'wins']
    }
  },
  handball: {
    name: 'Balonmano',
    icon: 'fa-hand-back-fist',
    color: '#1565c0',
    scoreLabel: 'Goles',
    scoringSystem: 'wdl',
    configTabs: ['scoring', 'overtime', 'match', 'knockout', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'gol', scorePlural: 'goles', period: 'tiempo', periodPlural: 'tiempos' },
    defaultConfig: {
      pointsWin: 2, pointsDraw: 1, pointsLoss: 0, allowDraw: true,
      hasOvertime: true, hasPenalties: true,
      pointsWinOvertime: 2, pointsLossOvertime: 0,
      pointsWinPenalties: 2, pointsLossPenalties: 0,
      matchDuration: 60, periods: 2, overtimeDuration: 10,
      knockoutTwoLegs: true, awayGoalsRule: true,
      tiebreakers: ['points', 'goalDifference', 'goalsFor', 'headToHead', 'wins']
    }
  },
  beach: {
    name: 'Fútbol Playa',
    icon: 'fa-umbrella-beach',
    color: '#00838f',
    scoreLabel: 'Goles',
    scoringSystem: 'wl',
    configTabs: ['scoring', 'overtime', 'match', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'gol', scorePlural: 'goles', period: 'periodo', periodPlural: 'periodos' },
    defaultConfig: {
      pointsWin: 3, pointsDraw: 0, pointsLoss: 0, allowDraw: false,
      hasOvertime: true, hasPenalties: true,
      pointsWinOvertime: 3, pointsLossOvertime: 0,
      pointsWinPenalties: 2, pointsLossPenalties: 1,
      matchDuration: 36, periods: 3, overtimeDuration: 3,
      knockoutTwoLegs: false, awayGoalsRule: false,
      tiebreakers: ['points', 'goalDifference', 'goalsFor', 'headToHead', 'wins']
    }
  },
  hockey: {
    name: 'Hockey',
    icon: 'fa-hockey-puck',
    color: '#0277bd',
    scoreLabel: 'Goles',
    scoringSystem: 'wdl',
    configTabs: ['scoring', 'overtime', 'match', 'knockout', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'gol', scorePlural: 'goles', period: 'cuarto', periodPlural: 'cuartos' },
    defaultConfig: {
      pointsWin: 3, pointsDraw: 1, pointsLoss: 0, allowDraw: true,
      hasOvertime: true, hasPenalties: true,
      pointsWinOvertime: 3, pointsLossOvertime: 0,
      pointsWinPenalties: 2, pointsLossPenalties: 1,
      matchDuration: 60, periods: 4, overtimeDuration: 10,
      knockoutTwoLegs: false, awayGoalsRule: false,
      tiebreakers: ['points', 'headToHead', 'goalDifference', 'goalsFor', 'wins']
    }
  },
  volleyball: {
    name: 'Voleibol',
    icon: 'fa-volleyball',
    color: '#7b1fa2',
    scoreLabel: 'Sets',
    scoringSystem: 'sets',
    configTabs: ['scoring', 'match', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'punto', scorePlural: 'puntos', period: 'set', periodPlural: 'sets' },
    defaultConfig: {
      // Puntos según el resultado del partido
      pointsWin3_0: 3, pointsWin3_1: 3, pointsWin3_2: 2,
      pointsLoss2_3: 1, pointsLoss1_3: 0, pointsLoss0_3: 0,
      allowDraw: false, hasOvertime: false, hasPenalties: false,
      pointsWinOvertime: 0, pointsLossOvertime: 0,
      pointsWinPenalties: 0, pointsLossPenalties: 0,
      // Configuración de match
      setsToWin: 3,           // 3 = mejor de 5 · 2 = mejor de 3
      pointsPerSet: 25,       // puntos para ganar un set normal
      pointsPerLastSet: 15,   // puntos para ganar el set definitivo
      matchDuration: 0, periods: 5, overtimeDuration: 0,
      knockoutTwoLegs: false, awayGoalsRule: false,
      tiebreakers: ['points', 'setsDifference', 'setsFor', 'pointsDifference', 'headToHead']
    }
  },
  padel: {
    name: 'Pádel',
    icon: 'fa-table-tennis-paddle-ball',
    color: '#00695c',
    scoreLabel: 'Sets',
    scoringSystem: 'sets-tennis',
    configTabs: ['scoring', 'match', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'punto', scorePlural: 'puntos', period: 'set', periodPlural: 'sets' },
    defaultConfig: {
      pointsWin: 3, pointsDraw: 0, pointsLoss: 0, allowDraw: false,
      hasOvertime: false, hasPenalties: false,
      pointsWinOvertime: 0, pointsLossOvertime: 0,
      pointsWinPenalties: 0, pointsLossPenalties: 0,
      // Configuración tenis/pádel
      setsToWin: 2,            // mejor de 3
      gamesPerSet: 6,          // ganar a 6 juegos
      tiebreakAt: 6,           // tiebreak cuando ambos llegan a 6
      finalSetTiebreak: false, // último set: tiebreak normal o super tie-break (10pts)
      matchDuration: 0, periods: 3, overtimeDuration: 0,
      knockoutTwoLegs: false, awayGoalsRule: false,
      tiebreakers: ['points', 'setsDifference', 'setsFor', 'headToHead', 'wins']
    }
  },
  tennis: {
    name: 'Tenis',
    icon: 'fa-table-tennis-paddle-ball',
    color: '#c8e6c9',
    scoreLabel: 'Sets',
    scoringSystem: 'sets-tennis',
    configTabs: ['scoring', 'match', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'punto', scorePlural: 'puntos', period: 'set', periodPlural: 'sets' },
    defaultConfig: {
      pointsWin: 3, pointsDraw: 0, pointsLoss: 0, allowDraw: false,
      hasOvertime: false, hasPenalties: false,
      pointsWinOvertime: 0, pointsLossOvertime: 0,
      pointsWinPenalties: 0, pointsLossPenalties: 0,
      setsToWin: 2,
      gamesPerSet: 6,
      tiebreakAt: 6,
      finalSetTiebreak: true,
      matchDuration: 0, periods: 3, overtimeDuration: 0,
      knockoutTwoLegs: false, awayGoalsRule: false,
      tiebreakers: ['points', 'setsDifference', 'setsFor', 'headToHead', 'wins']
    }
  },
  pelota: {
    name: 'Pelota',
    icon: 'fa-hand-back-fist',
    color: '#bf360c',
    scoreLabel: 'Tantos',
    scoringSystem: 'tantos',
    configTabs: ['scoring', 'match', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'tanto', scorePlural: 'tantos', period: 'partida', periodPlural: 'partidas' },
    defaultConfig: {
      pointsWin: 2, pointsDraw: 0, pointsLoss: 0, allowDraw: false,
      hasOvertime: false, hasPenalties: false,
      pointsWinOvertime: 0, pointsLossOvertime: 0,
      pointsWinPenalties: 0, pointsLossPenalties: 0,
      // Configuración pelota
      tantosToWin: 22,   // a 22 tantos (mano), 35 (pala), configurable
      matchDuration: 0, periods: 1, overtimeDuration: 0,
      knockoutTwoLegs: false, awayGoalsRule: false,
      tiebreakers: ['points', 'headToHead', 'pointsDifference', 'pointsFor', 'wins']
    }
  },
  rugby: {
    name: 'Rugby',
    icon: 'fa-football',
    color: '#4a148c',
    scoreLabel: 'Puntos',
    scoringSystem: 'wdl-bonus',
    configTabs: ['scoring', 'overtime', 'match', 'tiebreakers', 'visibility', 'sponsors'],
    terms: { score: 'punto', scorePlural: 'puntos', period: 'tiempo', periodPlural: 'tiempos' },
    defaultConfig: {
      pointsWin: 4, pointsDraw: 2, pointsLoss: 0, allowDraw: true,
      hasOvertime: true, hasPenalties: false,
      pointsWinOvertime: 4, pointsLossOvertime: 0,
      pointsWinPenalties: 0, pointsLossPenalties: 0,
      // Bonificaciones rugby
      bonusOffensive: 1,         // +1 punto si marcas 4+ ensayos
      bonusOffensiveTries: 4,    // umbral de ensayos
      bonusDefensive: 1,         // +1 punto si pierdes por <= 7 puntos
      bonusDefensiveMargin: 7,   // margen máximo
      matchDuration: 80, periods: 2, overtimeDuration: 20,
      knockoutTwoLegs: false, awayGoalsRule: false,
      tiebreakers: ['points', 'headToHead', 'pointsDifference', 'pointsFor', 'wins']
    }
  }
};

// ============================================
// SISTEMA DE TIERS DE ORGANIZACIÓN
// ============================================
//
// Cada organización tiene un tier que define sus límites de uso.
// -1 = ilimitado en cualquier campo numérico.
//
// Renovación: año móvil desde tierAssignedAt. Cuando vence pasa por estados:
//   active → expiring (≤30d) → grace (vencido <30d, solo lectura) → suspended (>30d post)
//
// Para "custom" tier, los límites se leen de org.customLimits (mismo schema).

export const TIERS = {
  free: {
    name: 'Free',
    label: 'Gratis (autoregistro)',
    color: '#9ca3af',
    price: 0,
    badge: '🆓',
    durationMonths: null, // No caduca por tiempo (sí por inactividad >180d)
    selfSignup: true,
  },
  tournament_unique: {
    name: 'Torneo Único',
    label: 'Torneo Único',
    color: '#a78bfa',
    price: 296,
    badge: '🎯',
    durationMonths: 12,
  },
  essential: {
    name: 'Essential',
    label: 'Esencial',
    color: '#9ca3af',
    price: 690,
    badge: '⭐',
    durationMonths: 12,
  },
  plus: {
    name: 'Plus',
    label: 'Plus',
    color: '#f0d878',
    price: 1290,
    badge: '⚡',
    durationMonths: 12,
  },
  pro: {
    name: 'Pro',
    label: 'Pro',
    color: '#3b82f6',
    price: 2190,
    badge: '👑',
    durationMonths: 12,
  },
  unlimited: {
    name: 'Unlimited',
    label: 'Ilimitado (regalo)',
    color: '#10b981',
    price: 0,
    badge: '🎁',
    durationMonths: null, // No caduca
  },
  custom: {
    name: 'Custom',
    label: 'A medida',
    color: '#ec4899',
    price: 0, // Configurable
    badge: '🛠️',
    durationMonths: 12, // Por defecto, configurable
  },
};

export const TIER_LIMITS = {
  free: {
    tournaments: 1, sports: 1, teams: 8, sponsors: 0,
    adminOrg: 1, admins: 0, tableUsers: 0,
    hasInscriptions: false, hasMobileApp: false, hasCRM: false,
    lockSportAfterCreate: true,
  },
  tournament_unique: {
    tournaments: 1, sports: 1, teams: 32, sponsors: 6,
    adminOrg: 1, admins: 1, tableUsers: 1,
    hasInscriptions: true, hasMobileApp: false, hasCRM: false,
    lockSportAfterCreate: false,
  },
  essential: {
    tournaments: 3, sports: 2, teams: 64, sponsors: 8,
    adminOrg: 1, admins: 1, tableUsers: 2,
    hasInscriptions: true, hasMobileApp: false, hasCRM: false,
    lockSportAfterCreate: false,
  },
  plus: {
    tournaments: 10, sports: 5, teams: 128, sponsors: 12,
    adminOrg: 2, admins: 5, tableUsers: -1,
    hasInscriptions: true, hasMobileApp: true, hasCRM: false,
    lockSportAfterCreate: false,
  },
  pro: {
    tournaments: -1, sports: -1, teams: -1, sponsors: -1,
    adminOrg: -1, admins: -1, tableUsers: -1,
    hasInscriptions: true, hasMobileApp: true, hasCRM: false,
    lockSportAfterCreate: false,
  },
  unlimited: {
    tournaments: -1, sports: -1, teams: -1, sponsors: -1,
    adminOrg: -1, admins: -1, tableUsers: -1,
    hasInscriptions: true, hasMobileApp: true, hasCRM: false,
    lockSportAfterCreate: false,
  },
};

// Etiquetas de los recursos limitables, para UI
export const TIER_RESOURCE_LABELS = {
  tournaments: 'torneos',
  sports: 'deportes',
  teams: 'equipos',
  sponsors: 'patrocinadores',
  adminOrg: 'admins de organización',
  admins: 'admins',
  tableUsers: 'mesas de partido',
};

export const TIEBREAKER_OPTIONS = {
  points: 'Puntos',
  goalDifference: 'Diferencia de goles',
  pointsDifference: 'Diferencia de puntos',
  goalsFor: 'Goles a favor',
  pointsFor: 'Puntos a favor',
  setsDifference: 'Diferencia de sets',
  setsFor: 'Sets a favor',
  headToHead: 'Enfrentamiento directo',
  wins: 'Victorias',
  losses: 'Menos derrotas',
  goalsAgainst: 'Menos goles en contra',
  random: 'Sorteo'
};

export const TOURNAMENT_FORMATS = {
  league: { name: 'Liga', description: 'Todos contra todos', icon: 'fa-list-ol' },
  knockout: { name: 'Eliminatorias', description: 'Eliminación directa', icon: 'fa-sitemap' },
  groups_knockout: { name: 'Grupos + Eliminatorias', description: 'Fase de grupos y eliminatorias', icon: 'fa-layer-group' },
  double_round: { name: 'Doble Vuelta', description: 'Liga ida y vuelta', icon: 'fa-rotate' }
};

// CLAVES internas en inglés (legado): referee = "Delegado" (gestiona, login email), viewer = "Mesa de partido" (mete resultados, login PIN)
export const USER_ROLES = {
  super_admin: { name: 'Super administrador', description: 'Control total', level: 100 },
  org_admin: { name: 'Administrador de organización', description: 'Gestiona su organización', level: 50 },
  referee: { name: 'Delegado', description: 'Gestiona equipos, resultados e inscripciones', level: 20 },
  viewer: { name: 'Mesa de partido', description: 'Mete resultados de partidos asignados', level: 10 }
};

export const KNOCKOUT_ROUNDS = {
  2: ['final'],
  4: ['semifinal', 'final'],
  8: ['cuartos', 'semifinal', 'final'],
  16: ['octavos', 'cuartos', 'semifinal', 'final'],
  32: ['dieciseisavos', 'octavos', 'cuartos', 'semifinal', 'final']
};

export const ROUND_NAMES = {
  'dieciseisavos': { es: 'Dieciseisavos', eu: 'Hamaseirenfinala', en: 'Round of 32' },
  'octavos': { es: 'Octavos de Final', eu: 'Zortziren Finala', en: 'Round of 16' },
  'cuartos': { es: 'Cuartos de Final', eu: 'Laurden Finala', en: 'Quarter Finals' },
  'semifinal': { es: 'Semifinal', eu: 'Finalerdia', en: 'Semi Finals' },
  'final': { es: 'Final', eu: 'Finala', en: 'Final' },
  'tercer_puesto': { es: 'Tercer Puesto', eu: 'Hirugarren Postua', en: 'Third Place' }
};
